import React from "react";
import { Helmet } from "react-helmet-async";
import { doc, setDoc } from "firebase/firestore";
import { auth, provider, db } from "../../Firebase_Config/firebaseConfig";
import { signInWithPopup } from "firebase/auth";
import { useNavigate, Link } from "react-router-dom";
import loginBanner from "../../Assets/LoginPage_Assets/login_banner.png";
import googleIcon from "../../Assets/LoginPage_Assets/google.png";
import { FaUserLock } from "react-icons/fa";
import "./Login.css";

const Login = (props) => {
  const navigate = useNavigate();

  const signInWithGoogle = () => {
    signInWithPopup(auth, provider)
      .then(async (result) => {
        const user = result.user;

        await setDoc(
          doc(db, "users", user.uid),
          {
            email: user.email,
            name: user.displayName,
            photoURL: user.photoURL,
            createdAt: new Date(),
          },
          { merge: true }
        );

        localStorage.setItem("isAdmin", "false");
        localStorage.setItem("authenticated", "true");
        props.setIsAdmin(false);
        props.setAuthenticated(true);

        props.setAlertMsg("You have been successfully logged in!");
        props.setAlertColor("lightgreen");

        navigate("/BlogHome");
      })
      .catch(() => {});
  };

  return (
    <>
    <div className="BackroundA pt-12"></div>
      <Helmet>
        <title>Login - VALSCO Blog</title>
      </Helmet>

      <main className="login-body">
        <h3 className="login-head">Login to create your own blogs</h3>

        <div className="login-div">
          <img src={loginBanner} id="login-img" alt="login-banner" />

          <div className="main-login-content">
            <button
              className="login-btn google-login-btn"
              onClick={signInWithGoogle}
            >
              <img src={googleIcon} alt="google-logo" className="button-icon" />
              <span>Continue with Google</span>
            </button>
          </div>

          {/* 🔐 NEW ADMIN DESIGN */}
          <div className="admin-section">
            <div className="admin-divider">Admin</div>

            <Link to="/AdminLogin" className="admin-entry">
              <FaUserLock className="admin-lock-icon" />
              <span>Administrator Login</span>
            </Link>
          </div>
        </div>
      </main>
    </>
  );
};

export default Login;
